var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3663_15610)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 6L21 13L17 17",
    stroke: "#0071BC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.8286 18.1721C6.09122 18.4348 6.40301 18.6432 6.74618 18.7853C7.08934 18.9275 7.45715 19.0007 7.8286 19.0007C8.20005 19.0007 8.56787 18.9275 8.91103 18.7853C9.25419 18.6432 9.56599 18.4348 9.8286 18.1721L20.4146 7.58607C20.6004 7.40035 20.7478 7.17983 20.8484 6.93713C20.9489 6.69442 21.0007 6.43429 21.0007 6.17157C21.0007 5.90886 20.9489 5.64872 20.8484 5.40602C20.7478 5.16331 20.6004 4.9428 20.4146 4.75707L19.2436 3.58607C19.0579 3.40027 18.8374 3.25288 18.5947 3.15232C18.352 3.05176 18.0918 3 17.8291 3C17.5664 3 17.3063 3.05176 17.0636 3.15232C16.8208 3.25288 16.6003 3.40027 16.4146 3.58607L5.8286 14.1721C5.56591 14.4347 5.35752 14.7465 5.21535 15.0896C5.07318 15.4328 5 15.8006 5 16.1721C5 16.5435 5.07318 16.9113 5.21535 17.2545C5.35752 17.5977 5.56591 17.9095 5.8286 18.1721Z",
    stroke: "#0071BC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 20.0004L5.768 18.2324",
    stroke: "#0071BC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3663_15610"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkIcon);
export default __webpack_public_path__ + "static/media/workIcon.7b475ad0af2ce1064ad2e16f2ec64be3.svg";
export { ForwardRef as ReactComponent };